class Map {
	constructor(data) {
		this.domEl = data.$el
		this.mapObj = {}
		this.markers = []

		data.zoom = +data.zoom || 10
		data.scrollwheel = data.scrollwheel || false
		data.center = {
			lat: +data.center.lat || 49.58,
			lng: +data.center.lng || 34.54
		}

		this.mapObj = new google.maps.Map(this._getElement(this.domEl), data)
	}

	$addMarker(coordinates) {
		let marker = new google.maps.Marker({
			position: coordinates,
			map: this.mapObj
		})

		this.markers.push(marker)

		return marker
	}

	$setCenter(coordinates) {
		this.mapObj.setCenter(coordinates)
	}

	_getElement(element) {
		if(element[0] === '#')
			return document.getElementById(element.replace('#', ''))
		else if(element[0] === '.')
			return document.getElementsByClassName(element.replace('.', ''))[0]
	}
}

export default Map



// WEBPACK FOOTER //
// ./src/common/Map.js